export const antennaDpTypeDefs = `

type AntennaConfig {
  antennaName: String!
  capabilities: [CapabilityState!]!
  isKnownAntenna: Boolean!
  lastUpdatedTimestamp: String!
}

type CapabilityState {
  capabilityId: String!
  capabilityName: String!
  devices: [DeviceState!]!
  status: String!
}

type DeviceConfig {
  antennaName: String!
  deviceInfoEntries: [DeviceInfoDataEntry!]!
  lastUpdatedTimestamp: String!
}

type DeviceInfoDataEntry {
  data: [StringMapEntry!]!
  deviceId: String!
  deviceInfoDataType: String!
}

type DeviceState {
  deviceId: String!
  status: String!
}

input GetAntennaConfigInput {
  antennaName: String
}

input GetDeviceConfigInput {
  antennaName: String
}

type Query {
  getAntennaConfig(cazJustification: String, input: GetAntennaConfigInput!): AntennaConfig
  getDeviceConfig(cazJustification: String, input: GetDeviceConfigInput!): DeviceConfig
}

type StringMapEntry {
  key: String
  value: String
}
`;
